import { css } from '@sail/ui';
export const angleStyles = css.global({
    ':root': {
        '--angleNormal': '-6deg',
        '--angleStrong': '-12deg',
        '--angleNormalSin': 0.106 /* Math.sin(-6º) */ ,
        '--angleStrongSin': 0.212 /* Math.sin(-12º) */ 
    }
});

//# sourceMappingURL=angle.js.map